export default __webpack_public_path__ + "static/media/ES.61454737.svg";